import { LitterFunction } from "custom/litterFunctions";
import { SuggestionBasedText, ItemGroup } from "pages/photo/types";
import { ReportStep } from "./types";
import actionTypes from "./actionTypes";

export function selectFunction(fn: LitterFunction) {
  return { type: actionTypes.SELECT_FUNCTION, payload: fn } as const;
}

export function addItem(fn: LitterFunction, category: SuggestionBasedText) {
  return {
    type: actionTypes.ADD_ITEM,
    payload: { fn, category }
  } as const;
}

export function removeItem(fn: LitterFunction, categoryId: string) {
  return {
    type: actionTypes.REMOVE_ITEM,
    payload: { fn, categoryId }
  } as const;
}

export function updateItemQuantity(
  fn: LitterFunction,
  categoryId: string,
  totalQuantity: number
) {
  return {
    type: actionTypes.UPDATE_ITEM_QUANTITY,
    payload: { fn, categoryId, totalQuantity }
  } as const;
}

export function updateItemGroups(
  fn: LitterFunction,
  categoryId: string,
  groups: ItemGroup[]
) {
  return {
    type: actionTypes.UPDATE_ITEM_GROUPS,
    payload: { fn, categoryId, groups }
  } as const;
}

export function setStep(step: ReportStep) {
  return { type: actionTypes.SET_STEP, payload: step } as const;
}

export function resetReport() {
  return { type: actionTypes.RESET } as const;
}
